import { render, staticRenderFns } from "./DisplayX1960.vue?vue&type=template&id=1dc2f0a8&"
import script from "./DisplayX1960.vue?vue&type=script&lang=js&"
export * from "./DisplayX1960.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports